import { NgModule } from '@angular/core';
import { DecimalInputComponent } from './shared/decimal-input/decimal-input.component';

@NgModule({
    declarations: [
        DecimalInputComponent,
    ],
    exports: [
        DecimalInputComponent
    ]
})
export class FinanceSharedModule {

}
